import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectPermsFragment = { __typename?: 'Project', permissions?: { __typename?: 'ProjectPermissions', canEditTranscription: boolean, canCopyComment: boolean, canDownloadComment: boolean, canDelete: boolean, canUpdate: boolean, canUpdateAsset: boolean, canCreateAsset: boolean, canShare: boolean, canCreateComment: boolean, canUpdateCommentStatus: boolean, canReactToComment: boolean, canViewComment: boolean, canCreateCommentAttachment: boolean, canDeleteComment: boolean, canDownloadCommentAttachment: boolean, canCopyAsset: boolean, canDeleteAsset: boolean, canMoveAsset: boolean, canDownloadAsset: boolean, canDeleteCollection: boolean, canUpdateCollection: boolean, canCreateCollection: boolean, canManageAssetMetadata: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean, canViewTranscription: boolean, canCreateTranscription: boolean, canDeleteTranscription: boolean, canDownloadTranscription: boolean, canCreateCaption: boolean, canDeleteCaption: boolean, canDownloadCaption: boolean, canViewCaption: boolean, canUpdateCaption: boolean } | null };

export const ProjectPerms = /*#__PURE__*/ gql`
    fragment ProjectPerms on Project {
  permissions {
    canEditTranscription
    canCopyComment
    canDownloadComment
    canDelete
    canUpdate
    canUpdateAsset
    canCreateAsset
    canShare
    canCreateComment
    canUpdateCommentStatus
    canReactToComment
    canViewComment
    canCreateCommentAttachment
    canDeleteComment
    canDownloadCommentAttachment
    canCopyAsset
    canDeleteAsset
    canMoveAsset
    canDownloadAsset
    canDeleteCollection
    canUpdateCollection
    canCreateCollection
    canManageAssetMetadata
    canEditUserPermissions
    canManageResourceControlPolicies
    canViewTranscription
    canCreateTranscription
    canDeleteTranscription
    canDownloadTranscription
    canCreateCaption
    canDeleteCaption
    canDownloadCaption
    canViewCaption
    canUpdateCaption
  }
}
    ` as unknown as DocumentNode<ProjectPermsFragment, unknown>;

        

        
export const useProjectPermsFragment = (
  input: string | Omit<UseFragmentOptions<ProjectPermsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectPermsFragment>({
    fragment: ProjectPerms,
    fragmentName: 'ProjectPerms',
    ...options,
  });
};
  
        